<template>
    <content-login-account v-if="activeIconMyAccount"
        :display="display"
        :displayMedia="displayMedia"
        :activeIconMyAccount="activeIconMyAccount"
        class="my-account-dropdown"
        >
        <!-- <a
            :href="!client ? $baseUrl + 'login' : '#'"
            :style="`font-size: ${show_minha_conta == true ? '10px' : '0px'};`"
            aria-label="Minha conta"
        >
            <span>{{ show_minha_conta == true ? "Minha Conta" : "" }}</span>
        </a> -->
        <a
            :href="!client ? $baseUrl + 'login' : '#'"
            :style="`font-size: ${show_minha_conta == true ? '14px' : '0px'};`"
            aria-label="Minha conta"
        >
            <i :class="user_icon_class"></i>
            <span>{{ show_minha_conta == true ? "Minha Conta" : "" }}</span>
        </a>
        <nav-login-app v-if="client" :sideLeft="side_left">
            <nav-brand-app top="0"><!-- 25px -->
                <nav-link-app>
                    <a :href="routeminhaconta" class="">Minha Conta</a>
                </nav-link-app>
                <nav-link-app>
                    <a :href="routewishlist" class="">Lista de desejos</a>
                </nav-link-app>
                <nav-link-app>
                    <a :href="routepurchases" class="">
                        Meus {{ isBudgetLayout ? 'orçamentos' : 'pedidos' }}
                    </a>
                </nav-link-app>
                <nav-link-app>
                    <a @click.prevent="logout()" href="" class="">Sair</a>
                </nav-link-app>
            </nav-brand-app>
        </nav-login-app>
    </content-login-account>
</template>

<script>
import {
    CNavbarLoginDrop,
    CNavBrand,
    CNavbarLink,
    CContentLoginAccount
} from "../Styles/Header/styled";
import { mapActions, mapState } from "vuex";

export default {
    name: "MenuMyAccount",
    components: {
        "nav-login-app": CNavbarLoginDrop,
        "nav-brand-app": CNavBrand,
        "nav-link-app": CNavbarLink,
        "content-login-account": CContentLoginAccount
    },
    props: {
        client_logged: {
            default: null
        },
        company: {
            default: null
        },
        routeminhaconta: {
            default: null
        },
        routewishlist: {
            default: null
        },
        routepurchases: {
            default: null
        },
        side_left: {
            default: false
        },
        show_minha_conta: {
            default: true
        },
        display: {
            default: 'block',
            type: String
        },
        displayMedia: {
            default: 'none',
            type: String
        },
    },
    async mounted() {
        this.ActionSetCompany(this.company);
        if (!this.client_logged.logged) {
            this.ActionSetClient(null);
            return;
        }
        this.ActionSetClient(this.client_logged.data);
    },
    methods: {
        ...mapActions("company", ["ActionSetSocials", "ActionSetCompany"]),
        ...mapActions("clients", ["ActionSetClient", "ActionLogout"]),
        async logout() {
            await this.ActionLogout()
                .then(response => {})
                .catch(error => {});
            window.location.href = this.$baseUrl;
        }
    },
    computed: {
        ...mapState("clients", ["client"]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        user_icon_class() {
            return this.$root.$children[0].theme?.user_icon_class ?? 'icon-user'
        },
        activeIconMyAccount() {
            return this.$root.$children[0].theme?.header?.active_icon_my_account ?? true
        },
    }
};
</script>
